import { Link } from "react-router-dom";
import { KeyRound, Network, Wrench } from "lucide-react";
import { ToolsLayout } from "@/components/organisms/tools/ToolsLayout";
import { useAuthStoreV1 } from "@/stores/authStore_v1";

export function StudioConnectionPage() {
  const selectedOrg = useAuthStoreV1((state) => state.selectedOrg);

  return (
    <div className="space-y-6">
      <section className="studio-hero">
        <div>
          <div className="studio-eyebrow">Connection - selected org context</div>
          <h1 className="studio-title">
            Connection manager <em>for Studio tools.</em>
          </h1>
          <p className="studio-subtitle">
            Studio uses the signed-in user and selected org to call graph, MCP tools, agents, and schedules.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/org360" className="studio-button">
            <Network className="h-4 w-4" />
            Check graph
          </Link>
          <Link to="/tools" className="studio-button studio-button-primary">
            <Wrench className="h-4 w-4" />
            Tool access
          </Link>
        </div>
      </section>

      <div className="grid gap-4 md:grid-cols-3">
        <Info icon={<KeyRound className="h-4 w-4" />} label="User context" value="inherited from login" />
        <Info icon={<Network className="h-4 w-4" />} label="Selected org" value={selectedOrg?.orgName || "No org selected"} />
        <Info icon={<Wrench className="h-4 w-4" />} label="Tools" value="MCP + graph scoped" />
      </div>

      <ToolsLayout />
    </div>
  );
}

function Info({ icon, label, value }: { icon: React.ReactNode; label: string; value: string }) {
  return (
    <div className="studio-card p-4">
      <div className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-md bg-muted text-foreground">{icon}</div>
      <div className="text-xs font-semibold uppercase text-muted-foreground">{label}</div>
      <div className="mt-1 truncate text-sm font-semibold">{value}</div>
    </div>
  );
}
